import { render, staticRenderFns } from "./CreateStatement.vue?vue&type=template&id=268d43a7"
import script from "./CreateStatement.vue?vue&type=script&lang=js"
export * from "./CreateStatement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports